import React, { useEffect } from 'react';
import { object, func, bool, string, number } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Translation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';

const styles = theme => ({
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: 0,
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: '#357a38',
    color: '#ffffff',
    fontWeight: '600',
  },
  linkButton: {
    marginTop: theme.spacing(2),
  },
  progress: {
    flexGrow: 1,
  },
  root: {},
  headerContainer: {},
  titleStyle: {},
  subTitle: {},
  itemMidContainer: {},
  footerContainer: {},
  footerBar: {},
  textFooterTerms: {},
  textFooter: {},
  trademarkText: {},
});

function RequestResetPassword(props) {
  const {
    email,
    emailChanged,
    emailError,
    isFetching,
    canReset,
    error = '',
    classes,
    resetInitiated,
    resetPassword,
    resetState,
    errorCode,
  } = props;

  useEffect(() => {
    resetState();
  }, [resetState]);

  function onSubmit(event) {
    event.preventDefault();
    resetPassword(email);
  }

  return (
    <Translation>
      {t => {
        if (resetInitiated) {
          return (
            <Grid container alignItems="center" justifyContent="space-around">
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  {t('emailResetPassword')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to="/login"
                  className={classes.button}
                >
                  {t('ok')}
                </Button>
              </Grid>
            </Grid>
          );
        }
        return (
          <form onSubmit={onSubmit}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-around"
              direction="row"
            >
              {isFetching && (
                <Grid item xs={12}>
                  <LinearProgress className={classes.progress} />
                </Grid>
              )}
              {error.length > 0 && (
                <Grid item xs={12}>
                  <Typography variant="caption" gutterBottom color="error">
                    {errorCode === 30006 ? t('noUserForEmail') : error}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={8}>
                <TextField
                  id="login-email"
                  name="email"
                  label={t('enterEmailAddress')}
                  autoComplete="email"
                  value={email}
                  onChange={event => emailChanged(event.target.value)}
                  className={classes.textField}
                  fullWidth
                  error={emailError.length > 0}
                  disabled={isFetching}
                />
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  type="submit"
                  className={classes.button}
                  fullWidth
                  disabled={isFetching || !canReset}
                >
                  {t('resetPassword')}
                </Button>
              </Grid>
            </Grid>
          </form>
        );
      }}
    </Translation>
  );
}

RequestResetPassword.propTypes = {
  classes: object.isRequired,
  email: string.isRequired,
  emailChanged: func.isRequired,
  canReset: bool.isRequired,
  resetPassword: func.isRequired,
  isFetching: bool.isRequired,
  emailError: string,
  error: string,
  errorCode: number,
  resetInitiated: bool.isRequired,
  resetState: func.isRequired,
};

export default withStyles(styles)(RequestResetPassword);



// WEBPACK FOOTER //
// ./src/view/forms/RequestResetPassword/RequestResetPassword.js